var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchBar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7913 20.8031L16.1112 15.2138C17.5986 13.5978 18.5126 11.4606 18.5126 9.10875C18.5118 4.07781 14.368 0 9.25592 0C4.14384 0 0 4.07781 0 9.10875C0 14.1397 4.14384 18.2175 9.25592 18.2175C11.4647 18.2175 13.4905 17.4535 15.0818 16.1834L20.7839 21.7947C21.0617 22.0684 21.5128 22.0684 21.7906 21.7947C22.0691 21.521 22.0691 21.0768 21.7913 20.8031ZM9.25592 16.8161C4.93054 16.8161 1.42415 13.3654 1.42415 9.10875C1.42415 4.85211 4.93054 1.40143 9.25592 1.40143C13.5813 1.40143 17.0877 4.85211 17.0877 9.10875C17.0877 13.3654 13.5813 16.8161 9.25592 16.8161Z",
    fill: "#8F9BB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBar);
export default __webpack_public_path__ + "static/media/SearchBar.2b4538b7cc0f60ab13cede9adce445d3.svg";
export { ForwardRef as ReactComponent };